import React from 'react'
import './MobileAppPrompt.css'

const APP_STORE_URL = 'https://apps.apple.com/us/app/wy-youth-resource-map/id6760038717'
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=org.casperyouthhub.resourcemap'

function MobileAppPrompt({ onContinue }) {
  return (
    <main className="mobile-app-prompt">
      <section className="mobile-app-prompt-card">
        <h1>Best Experience in the App</h1>
        <p>
          The Wyoming Youth Resource Map works on mobile web, but it is easier and faster in our iPhone and Android apps.
        </p>
        <div className="mobile-app-prompt-links">
          <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className="store-btn ios">
            Download on the App Store
          </a>
          <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" className="store-btn android">
            Get it on Google Play
          </a>
        </div>
        <button type="button" className="continue-web-btn" onClick={onContinue}>
          Continue to Web Map
        </button>
      </section>
    </main>
  )
}

export default MobileAppPrompt
